<template>
  <div
    class="carousel-header-component"
    :class="{ 'with-navigation': showNavigation }"
  >
    <div class="title-count">
      <header-text
        :level="'h3'"
        :size="'xxs'"
        :weight="'bold'"
      >
        <slot name="heading" />
      </header-text>
      <hlt-text
        v-if="itemCount"
        :inline="true"
        :size="'xs'"
        :variant="'content-secondary'"
        :weight="'semi'"
      >
        {{ itemText }}
      </hlt-text>
    </div>
    <router-link
      v-if="viewAllRoute"
      :to="viewAllRoute"
      class="view-all-link"
      @click.prevent="$emit('view-all-clicked')"
    >
      <hlt-text
        :inline="true"
        :size="'md'"
        :variant="'content-secondary'"
        :weight="'semi'"
      >
        View All
      </hlt-text>
    </router-link>
    <div
      v-if="showNavigation"
      class="carousel-navigation"
    >
      <button
        class="carousel-navigation-button"
        aria-label="Show previous"
        :disabled="!canNavigateLeft"
        @click="navigate('left')"
      >
        <icon
          class="arrow-icon"
          name="mastery-arrow-left"
          variant="b2b2b2"
        />
      </button>
      <button
        class="carousel-navigation-button"
        aria-label="Show next"
        :disabled="!canNavigateRight"
        @click="navigate('right')"
      >
        <icon
          class="arrow-icon"
          name="mastery-arrow-right"
          variant="b2b2b2"
        />
      </button>
    </div>
  </div>
</template>

<script>
import HeaderText from '@/components/ui/header-text.vue';
import HltText from '@/components/ui/text.vue';
import Icon from '@/components/singletons/icon.vue';

export default {
  components: { HeaderText, HltText, Icon },
  props: {
    canNavigateLeft: {
      type: Boolean,
    },
    canNavigateRight: {
      type: Boolean,
    },
    itemCount: {
      type: Number,
    },
    itemLabelSingular: {
      type: String,
      default: 'Item',
    },
    itemLabelPlural: {
      type: String,
      default: 'Items',
    },
    showNavigation: {
      type: Boolean,
      default: false,
    },
    viewAllRoute: {
      type: Object,
    },
  },
  emits: ['view-all-clicked', 'navigate'],
  computed: {
    itemText() {
      if (this.itemCount) {
        return `${this.itemCount} ${this.itemCount === 1 ? this.itemLabelSingular : this.itemLabelPlural}`;
      }
    },
  },
  methods: {
    navigate(direction) {
      this.$emit('navigate', direction);
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-header-component {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;

  .view-all-link {
    display: inline-block;
    margin-left: auto;
  }

  &.with-navigation {
    align-items: flex-start;
  }

  .carousel-navigation {
    margin-left: rem-calc(40);
    margin-top: rem-calc(-8);

    .carousel-navigation-button {
      align-items: center;
      border-radius: 100%;
      background: #f4f4f4;
      display: inline-flex;
      height: rem-calc(32);
      justify-content: center;
      width: rem-calc(32);

      &:disabled {
        opacity: .4;
      }
    }
  }

  @include breakpoint(small) {
    .view-all-link {
      align-self: flex-end;
    }

    .carousel-navigation {
      display: none;
    }
  }
}
</style>
